var map = {
	"./basic.vue": "1092",
	"./default.vue": "7b3d",
	"./defaultFullWidth.vue": "bb241",
	"./defaultWithoutSidebar.vue": "919f",
	"./defaultWithoutSidebarLogo.vue": "50ab",
	"./default_old.vue": "d973",
	"./iframe.vue": "8c44"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "81be";